// extracted by css-extract-rspack-plugin
export default {"root":"VSR_Lj"};